import InitTask from './InitTask';

export default InitTask.run.bind(InitTask);
